import { watch } from "vue";
import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";
import { isMobileApp } from "@sazka/mobile-apps/mobile-app-integration";
import { debounce } from "@sazka/utils/debounce";

const isXs1 = useBreakpoints("xs1");
const isSm = useBreakpoints("sm");
const isSm2 = useBreakpoints("sm2");

const FIXED_OFFSET = 8;
const isMobileAppView = isMobileApp;
let slotBar: HTMLElement = null;
let slotBarPosition: number;

function slotsBarSticky(slotBarParam: HTMLElement = null, isInitialLoad = false) {
    if (slotBarParam != null) {
        slotBar = slotBarParam;
    }

    if (!slotBar) return;

    if (!isInitialLoad) {
        slotBar.classList.remove("bm-slots-bar-sticky-on-mobile--fixed");
    }

    slotBarPosition = window.scrollY + slotBar.getBoundingClientRect().top;

    if (isInitialLoad) {
        window.addEventListener(
            "scroll",
            debounce(() => handleScroll(), 10)
        );
    }

    handleScroll();
}

function handleScroll() {
    if (!isXs1.value || isSm2.value) {
        slotBar.classList.remove("bm-slots-bar-sticky-on-mobile--fixed");
        return;
    }

    const topOffsetBecauseOfSecondaryMenu = isSm.value && !isMobileAppView ? 84 : 0;
    const scrollTop = window.scrollY;

    if (scrollTop > slotBarPosition - FIXED_OFFSET - topOffsetBecauseOfSecondaryMenu) {
        slotBar.classList.add("bm-slots-bar-sticky-on-mobile--fixed");
    } else {
        slotBar.classList.remove("bm-slots-bar-sticky-on-mobile--fixed");
    }
}

watch([isXs1, isSm, isSm2], () => {
    slotsBarSticky();
});

export default function useBonusomatSlotsBar() {
    return {
        slotsBarSticky,
    };
}
